<div class="rating-inner">
  <div class="rating-avg">{{ rating ? rating : 0 }}</div>
  <ngb-rating [rate]="rating" [max]="5" [readonly]="true" [primary]="primary"> </ngb-rating>
  <div *ngIf="count && count !== 0" class="rating-total">
    {{ count }}
  </div>
</div>
